<!--
 * @Descripttion:
 * @version:
 * @Author: Jeson
 * @Date: 2021-09-16 14:53:53
 * @LastEditors: Jerry
 * @LastEditTime: 2022-02-17 15:40:54
-->
<template>
  <div class="Content_Div">
    <div
      v-if="GiftList.length"
      class="Gift_Div"
      :style="{background:Background?Background:'#f1f7fe'}"
    >
      <div
        v-for="(item,index) in GiftList"
        :key="index"
        class="Gift_Div_List"
      >
        <div class="Gift_Div_Item">
          <div class="Gift_Div_Title">
            <div class="Gift_Div_Title_Label">赠品{{ index+1 }}</div>
            <div class="Gift_Div_Title_Img"><img :src="item.Type==3?require('../../../assets/coupon.png'):item.Logo"></div>
          </div>
          <div class="Gift_Div_Content">

            <div class="tags_box">
              <!-- 医保标签标签 -->
              <div
                v-for="properties in item.CommodityListProperties"
                v-if="properties.AttributeName == '医保类型'"
                :key="properties.Id"
                style="margin-right: 4px; font-size: 0;"
              >
                <img
                  v-if="properties.Value == 1"
                  src="@/assets/goods/class_a.png"
                  width="28px"
                  height="16px"
                >
                <img
                  v-if="properties.Value == 2"
                  src="@/assets/goods/class_b.png"
                  width="28px"
                  height="16px"
                >
                <img
                  v-if="properties.Value == 3"
                  src="@/assets/goods/yibao.png"
                  width="28px"
                  height="16px"
                >
              </div>
              <!-- 商品标签 -->
              <img
                v-if="item.GoodsTags && item.GoodsTags.length"
                :src="item.GoodsTags[0].Img"
                style="width: 32px; height: 16px;"
              >
              <div class="Gift_Div_Content_Name">
                {{ item.Type!=3?item.Name:'优惠券' }}
              </div>
            </div>

            <div
              v-if="item.Type!=3"
              class="Gift_Div_Content_Spc"
            >规格：{{ item.Specifications }}/{{ item.Unit }}</div>
            <div
              v-if="item.Type==3"
              class="Gift_Div_Content_Counp"
            >
              满{{ item.GoodsLimitPrice }}元{{ item.DeductionMode==1?'减':'打' }}{{ item.DeductionLimit }}{{ item.DeductionMode==1?'元':'折' }}
            </div>
            <div class="Gift_Div_Content_Amount">赠送数量：{{ item.Amount }} <label
              v-if="Multiple>1"
              class="number"
            >x {{ Multiple }}</label><span
              v-show="item.IsOutBusinessScope"
              class="Gift_Div_Content_Spc"
            >超出经营范围无法赠送</span>

              <span
                v-show="item.IsOutControl"
                class="Gift_Div_Content_Spc"
              >已被他人控销无法赠送</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'BuyCarGiftItemActivity',
  props: {
    dataSource: {
      type: Object,
      default: null
    },
    isNotClick: {
      type: Boolean,
      default: true
    },
    Background: {
      type: String,
      default: ''
    },
    Multiple: {
      type: Number,
      default: null
    },
    ChooseGiftNum: {
      type: Number,
      default: null
    },
    ActivityId: {
      type: String,
      default: ''
    },
    isByOrder: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      Show: true,
      GiftList: [],
      multipeNum: 1, // 每满， 每买 满足活动的次数
      preDataSource: null,
      isMeet: false, // 活动组商品是否满足当前活动内容
      themeType: null
    }
  },
  watch: {
    dataSource: {
      handler(v) {
        console.log(11111111111111)
        // 性能优化 dom存在多次更新情况
        if (this.preDataSource !== JSON.stringify(v)) {
          if (!v) return
          const { Activity = {}} = v
          const { ConfigType } = Activity
          // 只处理按订单的情况
          if (ConfigType !== 2) return
          this.GiftList = this.getActivePresentLists(v)
          this.preDataSource = JSON.stringify(v)
        }
      },
      immediate: true,
      deep: true
    },
    GiftList: {
      handler(v) {
        let totolNum = 0
        // 向父组件传递赠品数据信息
        this.$emit('syncSubmitActivitysFromActivity', {
          GiftList: v,
          dataSource: this.dataSource
        })
        if (v) {
          v.map(oo => {
            if (oo.IsMustSend) {
              totolNum++
            }
          })
          if (totolNum == v.length) {
            this.Show = false
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() { },
  created() { },
  methods: {
    // 获取专区活动满减的赠品列表
    getActivePresentLists(item) {
      const { Activity = {}} = item
      const { Configs, ConditionType } = Activity
      const { GoodsSkus } = item // 当前活动组所有商品
      const userChooseGoodsSkus = GoodsSkus.filter((item) => item.checked)
      const userChooseGoodsAllMoney = userChooseGoodsSkus.reduce(
        (add, item) => {
          const calcPrice = item.ActivityPrice ?? item.PriceLimit
          return add + calcPrice * item.Count
        },
        0
      )
      //  获取已满足的条件
      let userMeetConfig = null
      let lastCondition = 0
      // 每满时候 只取第一个配置项的数据
      ConditionType === 2 ? Configs.length = 1 : null
      Configs.forEach((element) => {
        if (
          userChooseGoodsAllMoney >= element.Condition &&
                    element.Condition >= lastCondition
        ) {
          lastCondition = element.Condition
          userMeetConfig = element
        }
      })
      // console.log('展示内容满足活动的配置---》', userMeetConfig)
      //   排序后取第一个
      Configs.sort((a, b) => {
        return a.Condition - b.Condition
      })[0]
      // console.log('为满足-默认展示条件配置---->', showDefaultConfig)

      if (!userMeetConfig) {
        return []
      } else if (ConditionType === 1) {
        // 满减 一次
        const {
          ActivityConfigPresent
        } = userMeetConfig
        // 如果是每买、每满  需乘以满足活动的次数
        return ActivityConfigPresent
      } else if (ConditionType === 2) {
        // 每满
        const { Condition, ActivityConfigPresent } = userMeetConfig
        const multNum = this.getMultipe(userChooseGoodsAllMoney, Condition) // 当前选中价格是条件的多少倍
        return ActivityConfigPresent.map(val => ({ ...val, Amount: multNum * val.Amount }))
      }
    },
    getMultipe(num, MultipleNum) {
      return parseInt(num / MultipleNum) || 1
    }
  }
}
</script>

<style lang='less' scoped>
@import url("./src/styles/BuyCarGiftItem.less");
</style>
